import{jsxs as h,jsx as i,Fragment as B}from"react/jsx-runtime";import{useState as E}from"react";import l,{css as $}from"styled-components";import r from"../../theme.js";import{Label as j}from"../FieldLabel.js";import{BodyTextStyle as N,CaptionStyle as S}from"../../typography/BodyText/index.js";import{useNameAndId as w}from"../../hooks/useNameAndId.js";import"../../shared/media-queries.js";import"../../shared/helpers.js";const A=$`
  border: 1px solid ${r.colors.grayscaleToned.light1};
  color: ${r.colors.grayscaleToned.dark1};
  fill: ${r.colors.grayscaleToned.light1};
`,I=$`
  border: 1px solid ${r.colors.error.dark};
`,C=$`
  color: ${r.colors.text.dark};
  border: 1px solid ${r.colors.text.dark};
  fill: ${r.colors.text.dark};
`,L=l.div`
  position: relative;
  padding: 0;
  display: inline-block;
`,D=l.div`
  display: inline-black;

  color: ${r.colors.grayscaleToned.light1};
  fill: ${r.colors.grayscaleToned.light1};
  background-color: ${r.colors.background.light};

  border: 1px solid ${r.colors.grayscaleToned.light1};
  transition: all 150ms;

  padding: 0.7rem 0.75rem;

  ${({hasError:e,isFocused:a})=>!e&&a&&C}
  ${({disabled:e})=>e&&A}
  ${({hasError:e})=>e&&I}
  ${({centered:e})=>e&&"text-align: center;"}
`,H=l.textarea`
  ${N}

  width: 100%;
  cursor: text;
  outline: none;
  border: none;
  background-color: transparent;

  ${({resize:e})=>!e&&"resize: none;"}
`,P=l.div`
  font-family: ${({theme:e})=>e.typography.fontBaseFamily};
`,V=l.div`
  ${S}
  margin-top: 0.25rem;

  ${({centered:e})=>e&&"width: 100%; text-align: center;"}
`,W=l.span`
  display: block;
  color: ${({theme:e})=>e.colors.text.disabled};
`,q=l.span`
  display: block;
  color: ${({theme:e})=>e.colors.error.dark};
`,u=({placeholder:e="",isDisabled:a=!1,centered:m=!1,hasError:b=!1,className:y,helperText:t,label:d="",resize:k=!0,name:v,errors:s,...n})=>{const[p,g]=E(!1),T=!!n.value,{name:x,id:o}=w("textarea",v),F=s?.map((f,c)=>`${o}-error-${c}`)??[],z=[t?`${o}-helper`:null,...F].filter(Boolean).join(" ");return h(L,{className:y,children:[h(D,{isFocused:p,disabled:a,centered:m,hasError:b,hasPlaceholder:!!e,children:[i(H,{...n,id:o,name:x,"aria-label":d?void 0:x,"aria-describedby":z||void 0,"aria-invalid":!!s?.length,resize:k,onFocus:()=>g(!0),onBlur:()=>g(!1),disabled:a,tabIndex:a?-1:0,theme:r,placeholder:d&&!p?"":e}),n.suffix&&i(P,{children:n.suffix})]}),d&&i(j,{htmlFor:o,isFocused:p,centered:m,hasError:b,hasValue:T,disabled:a,theme:r,children:h(B,{children:[d,i("span",{})]})}),(t||s)&&h(V,{centered:m,children:[t&&i(W,{id:`${o}-helper`,children:t}),s&&s.map((f,c)=>i(q,{id:`${o}-error-${c}`,role:"alert","aria-live":"assertive",children:f},`${o}-error-${c}`))]})]})};export{u as TextArea,u as default};
